// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.dropdown-trigger {
  width: 100%;
}

.course {
  width: 50px;
}
@media (max-width: 768px) {
.savecousebtn{
margin-top: 5px;
}
.text-justify{
  text-align: justify !important;
}
}
.main-margin{
margin-top: 4rem;
}
.bk-adm{
  background-color:#474559 !important;
  color: #fff !important;
  border: 2px solid white;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-weight: bold;
  /* font-size: large; */
  margin-top: 8px;
  display: block;
  text-wrap: nowrap;
}
.error-border {
  border: 1px solid #e93131;
  border-radius: 5px;
}
/* Ensure the error message does not push the input field */
.error-border + small {
  position: absolute;
  margin-top: 3px; 
}
.validation-message {
  position: absolute;
  bottom: -20px;
  margin-top: 0;  
}

.position-relative4 {
  position: relative;
}

.clear-input-icon4 {
  position: absolute;
  right: 7rem;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color:#333;
}
.position-relative-block {
  position: relative;
}

.clear-input-icon-block {
  position: absolute;
  right: 7rem;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color:#333;
}

@media (max-width: 768px) {
  .clear-input-icon-block {
    right: 13rem;
    top: 50%;
  }
}

@media (min-width: 350px) and (max-width: 557px) {
  .clear-input-icon-block {
    right: 10rem; /* Adjust the positioning as needed */
    top: 50%; /* Center the icon vertically */
  }

}
`, "",{"version":3,"sources":["webpack://./src/components/admin/Admin.css"],"names":[],"mappings":";AACA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;AACA;AACA;AACA,eAAe;AACf;AACA;EACE,8BAA8B;AAChC;AACA;AACA;AACA,gBAAgB;AAChB;AACA;EACE,mCAAmC;EACnC,sBAAsB;EACtB,uBAAuB;EACvB,4DAA4D;EAC5D,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;AACA,2DAA2D;AAC3D;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,UAAU;AACZ;;AAEA;EACE;IACE,YAAY;IACZ,QAAQ;EACV;AACF;;AAEA;EACE;IACE,YAAY,EAAE,qCAAqC;IACnD,QAAQ,EAAE,+BAA+B;EAC3C;;AAEF","sourcesContent":["\r\n.dropdown-trigger {\r\n  width: 100%;\r\n}\r\n\r\n.course {\r\n  width: 50px;\r\n}\r\n@media (max-width: 768px) {\r\n.savecousebtn{\r\nmargin-top: 5px;\r\n}\r\n.text-justify{\r\n  text-align: justify !important;\r\n}\r\n}\r\n.main-margin{\r\nmargin-top: 4rem;\r\n}\r\n.bk-adm{\r\n  background-color:#474559 !important;\r\n  color: #fff !important;\r\n  border: 2px solid white;\r\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n  font-weight: bold;\r\n  /* font-size: large; */\r\n  margin-top: 8px;\r\n  display: block;\r\n  text-wrap: nowrap;\r\n}\r\n.error-border {\r\n  border: 1px solid #e93131;\r\n  border-radius: 5px;\r\n}\r\n/* Ensure the error message does not push the input field */\r\n.error-border + small {\r\n  position: absolute;\r\n  margin-top: 3px; \r\n}\r\n.validation-message {\r\n  position: absolute;\r\n  bottom: -20px;\r\n  margin-top: 0;  \r\n}\r\n\r\n.position-relative4 {\r\n  position: relative;\r\n}\r\n\r\n.clear-input-icon4 {\r\n  position: absolute;\r\n  right: 7rem;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  cursor: pointer;\r\n  color:#333;\r\n}\r\n.position-relative-block {\r\n  position: relative;\r\n}\r\n\r\n.clear-input-icon-block {\r\n  position: absolute;\r\n  right: 7rem;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  cursor: pointer;\r\n  color:#333;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .clear-input-icon-block {\r\n    right: 13rem;\r\n    top: 50%;\r\n  }\r\n}\r\n\r\n@media (min-width: 350px) and (max-width: 557px) {\r\n  .clear-input-icon-block {\r\n    right: 10rem; /* Adjust the positioning as needed */\r\n    top: 50%; /* Center the icon vertically */\r\n  }\r\n\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
